var applyScrollerFit,
    kind = require("enyo/kind"),
    undoScrollerFit;

require("enyo-ui");

/**
 * [FitToScrollerSupport]{@link enyo-ui.FitToScrollerSupport} allows a control
 * to watch the dimensions of a scroller and scale itself to fill the scroller's
 * dimensions.
 *
 * @mixin enyo-ui.FitToScrollerSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.FitToScrollerSupport",

    /**
     * Selector path used to find the [Scroller]{@link enyo-ui.Scroller}
     * control.
     *
     * @name      scrollerPath
     * @type      {string}
     * @memberof  enyo-ui.FitToScrollerSupport
     * @public
     */

    /**
     * @memberof  enyo-ui.FitToScrollerSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.scrollerPathChanged();
            this.fitChanged();
        };
    }),

    /**
     * Update the referenced scroller if the path to the scroller has changed.
     *
     * @memberof  enyo-ui.FitToScrollerSupport
     * @private
     */
    scrollerPathChanged: function() {
        var oldScroller = this.getScroller(),
            newScroller;

        newScroller = this.get(this.get("scrollerPath"));

        if (oldScroller !== newScroller) {
            this.disconnectScroller();
            newScroller && this.connectScroller(newScroller);
        }
    },

    /**
     * Connects a new scroller.
     *
     * @param     {enyo-ui.Scroller}  scroller  The scroller
     * @memberof  enyo-ui.FitToScrollerSupport
     * @private
     */
    connectScroller: function(scroller) {
        this.set("scroller", scroller);
        scroller.observe("dimensions", this.onScrollerDimensionsChanged, this);
        scroller.observe("destroyed", this.onScrollerDestroyed, this);
    },

    /**
     * Disconnects the current scroller.
     *
     * @memberof  enyo-ui.FitToScrollerSupport
     * @private
     */
    disconnectScroller: function() {
        var scroller = this.getScroller();

        if (scroller) {
            scroller.unobserve("dimensions", this.onScrollerDimensionsChanged);
            scroller.unobserve("destroyed", this.onScrollerDestroyed);
        }
        this.set("scroller", null);
    },

    /**
     * Disconnect scroller if it gets destroyed
     *
     * @memberof  enyo-ui.FitToScrollerSupport
     * @private
     */
    onScrollerDestroyed: function() {
        this.disconnectScroller();
    },

    /**
     * Gets the scroller control.
     *
     * @return  {?enyo-ui.Scroller}  The scroller
     * @public
     */
    getScroller: function() {
        return this.scroller || null;
    },

    /**
     * @memberof  enyo-ui.FitToScrollerSupport
     * @method
     * @private
     */
    onScrollerDimensionsChanged: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.get("fit")) {
                this.applyScrollerFit ? this.applyScrollerFit(this) : applyScrollerFit(this);
            }
        };
    }),

    /**
     * @private
     */
    reflow: kind.inherit(function(sup) {
        return function() {
            this.updateScrollerFit();
            sup.apply(this, arguments);
        };
    }),

    /**
     * @memberof  enyo-ui.FitToScrollerSupport
     * @method
     * @private
     */
    fitChanged: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.updateScrollerFit();
            this.resize();
        };
    }),

    /**
     * @private
     */
    updateScrollerFit: function() {
        if (this.get("fit")) {
            this.applyScrollerFit ? this.applyScrollerFit(this) : applyScrollerFit(this);
        }
        else {
            this.undoScrollerFit ? this.undoScrollerFit(this) : undoScrollerFit(this);
        }
    },

    /**
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            this.disconnectScroller();
            sup.apply(this, arguments);
        };
    })

};

/**
 * Fit the control to the scroller
 *
 * @param  {enyo.Control}  control  The control
 * @public
 */
applyScrollerFit = function(control) {
    var scroller,
        dimensions;

    scroller   = control.getScroller();
    dimensions = scroller ? scroller.get("dimensions") : null;

    if (dimensions) {
        control.addStyles({
            "min-width":  dimensions.scrollerWidth + "px",
            "min-height": dimensions.scrollerHeight + "px"
        });
    }
    else {
        control.undoScrollerFit ? control.undoScrollerFit() : undoScrollerFit();
    }
};

/**
 * Undo fitting the control to the scroller
 *
 * @param  {enyo.Control}  control  The control
 * @public
 */
undoScrollerFit = function(control) {
    control.addStyles({
        "min-width":  null,
        "min-height": null
    });
};
